// src/utils/exportUtils.js

export const exportToCSV = (shops) => {
  // Headers
  const headers = [
    'ID',
    'Nom',
    'Domaine',
    'Description',
    'Catégorie',
    'Logo',
    'Téléphone principal',
    'Adresse principale',
    'Numéro premium',
    'Tarif premium',
    'RCS',
    'Statut',
    'Date de scraping',
    'Validé par',
    'Date de validation'
  ];

  // Convert shops to CSV rows
  const rows = shops.map(shop => [
    shop._id || '',
    shop.name || '',
    shop.domain || '',
    shop.description || '',
    shop.category || '',
    shop.logo || '',
    shop.mainPhone || '',
    shop.mainAddress || '',
    shop.premiumPhone || '',
    shop.premiumRate || '',
    shop.rcs || '',
    shop.status || '',
    shop.scrapedAt ? new Date(shop.scrapedAt).toLocaleDateString('fr-FR') : '',
    shop.validatedBy || '',
    shop.validatedAt ? new Date(shop.validatedAt).toLocaleDateString('fr-FR') : ''
  ]);

  // Combine headers and rows
  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(','))
  ].join('\n');

  // Create blob and download
  const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', `boutiques_${new Date().toISOString().slice(0, 10)}.csv`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const parseCSV = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      const text = e.target.result;
      const lines = text.split('\n');
      
      if (lines.length < 2) {
        reject(new Error('Fichier CSV vide'));
        return;
      }
      
      // Parse rows
      const shops = [];
      for (let i = 1; i < lines.length; i++) {
        if (!lines[i].trim()) continue;
        
        const values = lines[i].match(/(".*?"|[^,]+)(?=\s*,|\s*$)/g) || [];
        const row = values.map(v => v.trim().replace(/^"|"$/g, '').replace(/""/g, '"'));
        
        if (row.length > 0) {
          const shop = {
            name: row[1] || '',
            domain: row[2] || '',
            description: row[3] || '',
            category: row[4] || '',
            logo: row[5] || '',
            mainPhone: row[6] || '',
            mainAddress: row[7] || '',
            premiumPhone: row[8] || '',
            premiumRate: row[9] || '',
            rcs: row[10] || ''
          };
          shops.push(shop);
        }
      }
      
      resolve(shops);
    };
    
    reader.onerror = () => reject(new Error('Erreur de lecture du fichier'));
    reader.readAsText(file, 'UTF-8');
  });
};

export const parseExcel = async (file) => {
  // Cette fonction nécessiterait une bibliothèque comme xlsx
  // Pour l'instant, on retourne une erreur
  throw new Error('L\'import Excel nécessite l\'installation de la bibliothèque xlsx');
};